import { FunctionComponent } from "react";
import { HeartOutlined, LoginOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";
import { useAuth } from "../../hooks/AuthContext";
import { TileCard } from "./TileCard";

export const Home: FunctionComponent = () => {
    const { username } = useAuth();

    const tiles = [
        {
            icon: <TeamOutlined />,
            iconVariant: "navy" as const,
            title: "Cours d'arabe — Enfants",
            subtitle: "Inscrire mon enfant",
            cta: "Commencer →",
            to: "/coursEnfants",
        },
        {
            icon: <UserOutlined />,
            iconVariant: "navy" as const,
            title: "Cours d'arabe — Adultes",
            subtitle: "M'inscrire aux cours",
            cta: "Commencer →",
            to: "/coursAdultes",
        },
        {
            icon: <HeartOutlined />,
            iconVariant: "orange" as const,
            title: "Adhérer à l'association",
            subtitle: "Devenir membre de l'AMC",
            cta: "Commencer →",
            to: "/adhesionInfos",
        },
        {
            icon: <LoginOutlined />,
            iconVariant: "blue" as const,
            title: "Mon espace",
            subtitle: "Déjà inscrit ?",
            cta: "Se connecter →",
            to: username ? "/mesInscriptions" : "/login",
        },
    ];

    return (
        <div className="home-hub">
            <section className="home-hero">
                <div className="home-hero-logo" />
                <h1 className="home-hero-title">Association Musulmane du Chablais</h1>
                <p className="home-hero-tagline">Cours d'arabe · Adhésion · Vie de la mosquée</p>
                <p className="home-hero-loc">📍 Thonon-les-Bains</p>
            </section>

            <section className="home-tiles">
                {tiles.map((tile) => (
                    <TileCard key={tile.title} {...tile} />
                ))}
            </section>
        </div>
    );
};
